var $01b62a0613005415$exports = {};
$01b62a0613005415$exports = {
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "placeholder": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}\u{2026}`
};


export {$01b62a0613005415$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
